// src/Screens/Components/ProgressBar.tsx

import React from 'react';

type ProgressBarProps = {
  categories: string[];
  currentCategory: number;
};

const ProgressBar: React.FC<ProgressBarProps> = ({ categories, currentCategory }) => {
  const progress = ((currentCategory + 1) / categories.length) * 100;

  return (
    <div className="w-full mb-6">
      <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem', paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.5rem'}}>
        {categories.map((category, index) => (
          <div 
            key={category} 
            className={`text-sm ${index <= currentCategory ? 'text-[#106cb8] font-semibold' : 'text-gray-400'}`}
          >
            {category}
          </div>
        ))}
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5 relative">
        <div
          className="bg-[#106cb8] h-2.5 rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
